module.exports = __webpack_public_path__ + "static/media/2022-02-27 15.06.38.9414a025.png";